import { UniqueLinkPsidUploadResult } from '@ps/survey-utils';

import {
  BuyerUploadedRespondentListResponseDto,
  UniqueLinkPsidFileResponseDto,
  UploadRespondentListResponseDto,
} from '../dtos/respondent-list.dto';

export class RespondentListMapper {
  public fromUploadDto(dto: UploadRespondentListResponseDto): string[] {
    return dto.PSIDRef;
  }

  public fromUploadedListDto(
    dto: BuyerUploadedRespondentListResponseDto,
  ): string[] {
    return dto.psids.map((record) => record.PSID);
  }

  public fromUniqueLinkPsidFileDto({
    data,
  }: UniqueLinkPsidFileResponseDto): UniqueLinkPsidUploadResult {
    return {
      links: data.uniq_psids.map(({ psid, url }) => ({ psid, url })),
      uploadedCount: data.uploaded_psid,
      skippedCount: data.skipped_psid,
    };
  }
}
